import React from 'react';
import { doutoAnnualDiscountUrl, doutoMonthlyTrialUrl, personalCode } from '../../lib/doutoOnboarding';
import { useLocale } from '../LocaleProvider';

// Preço real do plano anual do Douto no Payments Hub: R$590,00/ano. 25% off = R$442,50/ano.
const ANNUAL_LIST_PRICE = 'R$590';
const ANNUAL_DISCOUNT_PRICE = 'R$442,50/ano';
const ANNUAL_MONTHLY_EQUIVALENT = '≈ R$36,88/mês';
const ANNUAL_SAVINGS = 'R$147,50';

/**
 * Conteúdo da oferta do Douto, compartilhado entre o passo final do onboarding
 * (OnboardingFlow) e o popup de reengajamento (DoutoReengagementPopup). O anual é a
 * opção em destaque; o mensal é uma saída discreta, não um segundo cartão concorrente.
 *
 * O "código pessoal" exibido (personalCode) é só de exibição — gerado a partir do
 * e-mail, determinístico por conta, mas nunca é o que o checkout do Douto valida.
 * Quem valida é o cupom real (DOUTO_ANNUAL_COUPON), aplicado pelo link automaticamente.
 * Por isso a letra miúda nunca convida a digitar o código pessoal em lugar nenhum.
 */
export default function DoutoOfferPanel({ context, name, email, onLinkClick }) {
  const { locale, t } = useLocale();
  const utmContent = context === 'reengagement' ? 'reengajamento' : 'onboarding';
  const firstName = String(name || '').trim().split(/\s+/)[0];
  const code = personalCode(email || name || context);

  return (
    <div>
      <div className="rounded-[var(--radius-block)] border border-[var(--accent)] bg-[var(--accent-tint)] p-5 md:p-6">
        <h3 className="text-lg font-semibold text-[var(--primary)]">{t('offerTitle')}</h3>
        <p className="mt-2 text-sm leading-relaxed text-[var(--ink)]">{t('offerBody')}</p>

        <span className="mt-4 inline-flex items-center rounded-full bg-[var(--primary)] px-3 py-1 text-sm font-bold text-[var(--on-accent)]">{t('save')} {ANNUAL_SAVINGS}</span>

        <p className="mt-3">
          <span className="score-figure text-xl text-[var(--text-muted)] line-through">{ANNUAL_LIST_PRICE}</span>{' '}
          <span className="score-figure text-3xl text-[var(--primary)]">{ANNUAL_DISCOUNT_PRICE}</span>{' '}
          <span className="text-sm text-[var(--text-muted)]">{ANNUAL_MONTHLY_EQUIVALENT}</span>
        </p>

        <a
          href={doutoAnnualDiscountUrl(utmContent)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => onLinkClick?.('anual')}
          className="btn-primary mt-4 inline-flex w-full sm:w-auto"
        >
          {t('redeem')} <span aria-hidden="true">↗</span>
        </a>

        <div className="mt-4 rounded-[var(--radius-block)] bg-[var(--surface)] px-4 py-3">
          <p className="eyebrow text-xs">{firstName ? (locale === 'es' ? `Tu código exclusivo, ${firstName}` : `Seu código exclusivo, ${firstName}`) : t('exclusive')}</p>
          <p className="mono mt-1.5 text-lg tracking-[0.08em] text-[var(--primary)]">{code}</p>
          <p className="mt-1.5 text-xs text-[var(--text-muted)]">{t('activated')}</p>
        </div>
      </div>

      <p className="mt-4 text-sm">
        {t('startSlow')}{' '}
        <a
          href={doutoMonthlyTrialUrl(utmContent)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => onLinkClick?.('mensal')}
          className="font-semibold text-[var(--primary)] underline"
        >
          {t('freeTrial')} <span aria-hidden="true">↗</span>
        </a>
      </p>
      <p className="mt-1 text-xs text-[var(--text-muted)]">{t('after')}</p>
    </div>
  );
}
